import axios from 'axios'

export const GEODESIA_MAP_LAYER_KEYS = [
  'vrsCoordinates',
  'jxlCoordinates',
  'jxlRw5Coordinates',
  'jxlRawCoordinates',
  'jxlPolygons',
  'jxlBaselineLines',
]

export const GEODESIA_POINT_LAYER_KEYS = [
  'jxlCoordinates',
  'jxlRw5Coordinates',
  'jxlRawCoordinates',
]

export const GEODESIA_LAYER_SOURCE = {
  jxlCoordinates: 'jxl',
  jxlRw5Coordinates: 'rw5',
  jxlRawCoordinates: 'raw',
}

export const GEODESIA_LAYER_COLLECTION_KEY = {
  vrsCoordinates: 'points',
  jxlCoordinates: 'points',
  jxlRw5Coordinates: 'points',
  jxlRawCoordinates: 'points',
  jxlPolygons: 'polygons',
  jxlBaselineLines: 'base_lines',
}

export const GEODESIA_LAYER_ERROR_MESSAGE = {
  vrsCoordinates: 'فشل تحميل إحداثيات VRS',
  jxlCoordinates: 'فشل تحميل إحداثيات JXL',
  jxlRw5Coordinates: 'فشل تحميل إحداثيات RW5',
  jxlRawCoordinates: 'فشل تحميل إحداثيات RAW',
  jxlPolygons: 'فشل تحميل مضلعات JXL',
  jxlBaselineLines: 'فشل تحميل خطوط الأساس (JXL)',
}

export const GEODESIA_LAYER_TRUNCATED_MESSAGE = 'تم عرض أول 20000 عنصر — قرّب الخريطة أو صفِّ المشروع'

const DEFAULT_MAP_LAYER_PARAMS = {
  paginate: false,
  per_page: 10000,
}

export function buildGeodesiaMapLayerParams(extra = {}) {
  const params = { ...DEFAULT_MAP_LAYER_PARAMS, ...extra }
  const cleaned = {}
  Object.keys(params).forEach(key => {
    const value = params[key]
    if (value === null || value === undefined || value === '') return
    cleaned[key] = value
  })
  return cleaned
}

export function unwrapGeodesiaLayerPayload(response) {
  if (!response) return {}
  if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
    return response.data
  }
  return response
}

export function getGeodesiaLayerFeatures(payload, layerKey) {
  const collectionKey = GEODESIA_LAYER_COLLECTION_KEY[layerKey]
  const items = payload?.[collectionKey]
  return Array.isArray(items) ? items : []
}

export function isGeodesiaLayerTruncated(payload) {
  return payload?.meta?.truncated === true
}

export function geodesiaLayerErrorMessage(error, layerKey) {
  return error?.response?.data?.message
    || error?.message
    || GEODESIA_LAYER_ERROR_MESSAGE[layerKey]
    || 'فشل تحميل طبقة الخريطة'
}

export function createGeodesiaLayerCancelSource() {
  return axios.CancelToken.source()
}

export function isGeodesiaLayerRequestCanceled(error) {
  return axios.isCancel(error)
}

export function hexColorToRgb(hex, fallback = [0, 153, 255]) {
  const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(String(hex || '').trim())
  if (!match) return fallback.slice()
  return [
    parseInt(match[1], 16),
    parseInt(match[2], 16),
    parseInt(match[3], 16),
  ]
}

export function isFiniteLngLat(lng, lat) {
  return Number.isFinite(Number(lng)) && Number.isFinite(Number(lat))
}
